// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormControl[data-v-7b2f3c09]{--form-gap: .5rem;--label-width: 120px;display:flex;flex-wrap:wrap;flex-direction:column;gap:var(--form-gap)}.FormControl .FormLabel[data-v-7b2f3c09]{margin-bottom:.25rem}\n", ""]);
// Exports
module.exports = exports;
